import Css from "./style.module.scss";

import React from "react";
import classNames from "classnames";

const SideBarContent = ({ className, children, ...restProps }) => {
  return (
    <div className={classNames(Css.sideBarContent, className)} {...restProps}>
      {children}
    </div>
  );
};

export default React.memo(SideBarContent);
